export function initScrollToTop(): void {
    const btn = document.getElementById('scrollToTop');

    if (!btn) {
        return;
    }

    btn.addEventListener('click', (): void => {
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            const start = window.scrollY;
            const duration = 400;
            const startTime = performance.now();

            const step = (now: number) => {
                const elapsed = now - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3);

                window.scrollTo(0, start * (1 - eased));

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };

            requestAnimationFrame(step);
        }
    });

    window.addEventListener('scroll', (): void => {
        if (window.scrollY > 100) {
            btn.classList.add('show');
        } else {
            btn.classList.remove('show');
        }
    });
}